<div class="container static-page">
    <h4>{{ 'home.pages.help.title' | translate }}</h4>

    <div class="static-page-block">
        <h5>{{ 'home.pages.help.presentationWudo.title' | translate }}</h5>
        <div class="video-wrapper">
            <div class="video-container">
                <iframe
                    title="Présentation de la plateforme Wudo"
                    src="https://www.youtube.com/embed/AKtUyuPeFog"
                    class="frameborder-less"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe>
            </div>
        </div>
    </div>

    <div class="static-page-block">
        <h5>{{ 'home.pages.help.presentationWudoMobile.title' | translate }}</h5>
        <div class="row">
            <div class="col-md-6">
                <h6>{{ 'home.pages.help.presentationWudoMobile.titleIOS' | translate }}</h6>
                <div class="video-wrapper">
                    <div class="video-container">
                        <iframe
                            title="'home.pages.help.sections.presentationWudoMobile.titleIOS' | translate "
                            src="https://www.youtube.com/embed/myYpKUWt42c"
                            class="frameborder-less"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <h6>{{ 'home.pages.help.presentationWudoMobile.titleAndroid' | translate }}</h6>
                <div class="video-wrapper">
                    <div class="video-container">
                        <iframe
                            title="'home.pages.help.sections.presentationWudoMobile.titleAndroid' | translate "
                            src="https://www.youtube.com/embed/_51JNySfxIg"
                            class="frameborder-less"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="static-page-block">
        <h5>
            {{ 'home.pages.help.sections.manageProjects.title' | translate }}
        </h5>
        <div class="row">
            <div class="col-md-4">
                <h6>{{ 'home.pages.help.sections.manageProjects.accessProjects' | translate }}</h6>
                <div class="video-wrapper">
                    <div class="video-container">
                        <iframe
                            [title]="'home.pages.help.sections.manageProjects.accessProjects' | translate"
                            src="https://www.youtube.com/embed/druB4QLAgOE"
                            class="frameborder-less"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <h6>{{ 'home.pages.help.sections.manageProjects.createProject' | translate }}</h6>
                <div class="video-wrapper">
                    <div class="video-container">
                        <iframe
                            [title]="'home.pages.help.sections.manageProjects.createProject' | translate"
                            src="https://www.youtube.com/embed/M3OzwHpIYA8"
                            class="frameborder-less"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <h6>{{ 'home.pages.help.sections.manageProjects.finalizeProject' | translate }}</h6>
                <div class="video-wrapper">
                    <div class="video-container">
                        <iframe
                            [title]="'home.pages.help.sections.manageProjects.finalizeProject' | translate"
                            src="https://www.youtube.com/embed/5z1GLPwBOA4"
                            class="frameborder-less"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
        <h6>{{ 'home.pages.help.sections.manageProjects.communicateTeam' | translate }}</h6>
        <div class="video-wrapper">
            <div class="video-container">
                <iframe
                    title="'home.pages.help.sections.manageProjects.communicateTeam' | translate"
                    src="https://www.youtube.com/embed/_mDGx1zM6k4"
                    class="frameborder-less"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe>
            </div>
        </div>
    </div>

    <div class="static-page-block">
        <h5>
            {{ 'home.pages.help.sections.collaborateProject.title' | translate }}
        </h5>
        <div class="row">
            <div class="col-md-4">
                <h6>
                    {{ 'home.pages.help.sections.collaborateProject.findProjects' | translate }}
                </h6>
                <div class="video-wrapper">
                    <div class="video-container">
                        <iframe
                            [title]="'home.pages.help.sections.collaborateProject.findProjects' | translate"
                            src="https://www.youtube.com/embed/ECKP87uWYIw"
                            class="frameborder-less"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <h6>{{ 'home.pages.help.sections.collaborateProject.joinProject' | translate }}</h6>
                <div class="video-wrapper">
                    <div class="video-container">
                        <iframe
                            [title]="'home.pages.help.sections.collaborateProject.joinProject' | translate"
                            src="https://www.youtube.com/embed/S-AWRoKoSfY"
                            class="frameborder-less"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <h6>{{ 'home.pages.help.sections.collaborateProject.leaveProject' | translate }}</h6>
                <div class="video-wrapper">
                    <div class="video-container">
                        <iframe
                            [title]="'home.pages.help.sections.collaborateProject.leaveProject' | translate"
                            src="https://www.youtube.com/embed/llmTDKpizOI"
                            class="frameborder-less"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="static-page-block">
        <h5>{{ 'home.pages.help.sections.searchMembers.title' | translate }}</h5>
        <div class="video-wrapper">
            <div class="video-container">
                <iframe
                    title="'home.pages.help.sections.searchMembers.title' | translate"
                    src="https://www.youtube.com/embed/zUEcMD3Aq6M"
                    class="frameborder-less"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe>
            </div>
        </div>
    </div>

    <div class="static-page-block">
        <h5>{{ 'home.pages.help.sections.communicateActualities.title' | translate }}</h5>
        <div class="video-wrapper">
            <div class="video-container">
                <iframe
                    title="'home.pages.help.sections.communicateActualities.title' | translate"
                    src="https://www.youtube.com/embed/4k_DpiCckkM"
                    class="frameborder-less"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe>
            </div>
        </div>
    </div>

    <div class="static-page-block">
        <h5>{{ 'home.pages.help.sections.modifyInformations.title' | translate }}</h5>
        <div class="video-wrapper">
            <div class="video-container">
                <iframe
                    title="'home.pages.help.sections.modifyInformations.title' | translate"
                    src="https://www.youtube.com/embed/nPBi6zg12io"
                    class="frameborder-less"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe>
            </div>
        </div>
    </div>

    <div class="static-page-block">
        <p class="text-center">
            {{ 'home.pages.help.sections.supportSection.title' | translate }}
            <a href="mailto:{{ 'home.pages.help.sections.supportSection.supportMail' | translate }}" rel="noopener noreferrer">{{
                'home.pages.help.supportMail' | translate
            }}</a>
        </p>
    </div>

    <div class="static-page-block">
        <p class="text-center">
            {{ 'home.pages.help.sections.follow.titlePart1' | translate }}
            <a href="https://twitter.com/WuDo_io" target="_blank" rel="noopener noreferrer">Twitter</a>,
            <a href="https://www.linkedin.com/company/wu-do" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            {{ 'home.pages.help.sections.follow.titlePart2' | translate }}
        </p>
        <img class="rounded mx-auto d-block" src="./assets/images/wudo-logo.png" alt="WuDo" />
    </div>
</div>
